import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getActionLabel } from '../utils/historyHelpers'
import AccountsList from './AccountsList'
import { HistoryItem, AccountType } from '../types'

interface HistoryItemAccountsProps {
  item: HistoryItem
  accountType: AccountType
  isLast: boolean
}

const HistoryItemAccounts: React.FC<HistoryItemAccountsProps> = ({ 
  item, 
  accountType, 
  isLast 
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (accountType === 'parent_accounts' || accountType === 'site_accounts') {
    return null
  }

  if (!item.context?.[accountType]?.length) return null

  const accounts = item.context[accountType]

  const getTitle = (): string => {
    switch (accountType) {
      case 'added_accounts':
        return t('auth.history.sites_added', 'Ajout - Sites')
      case 'removed_accounts':
        return t('auth.history.sites_removed', 'Suppression - Sites')
      default:
        return ''
    }
  }

  return (
    <Box
      sx={{
        pb: isLast ? 0 : 2,
        position: 'relative',
        pl: 2,
      }}
    >
      <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', display: 'flex' }}>
        <Box sx={{ width: '12px', position: 'relative' }}>
          <Box sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '10px',
            width: 0,
            borderLeft: `solid 1px ${theme.palette.grey[100]}`,
          }} />

          <Box sx={{
            position: 'absolute',
            left: 0,
            top: '10px',
            width: '12px',
            height: 0,
            borderTop: `solid 1px ${theme.palette.grey[100]}`,
            borderTopLeftRadius: 6,
          }} />

          {!isLast && (
            <Box sx={{
              position: 'absolute',
              left: 0,
              top: '10px',
              bottom: 0,
              width: 0,
              borderLeft: `solid 1px ${theme.palette.border.primary}`,
            }} />
          )}
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: 10,
          color: theme.palette.text.secondary,
          pb: 0.5
        }}
      >
        {getActionLabel(item.routing_key || item.action, t)} - {getTitle()}
      </Typography>
      <AccountsList accounts={accounts} />
    </Box>
  )
}

export default HistoryItemAccounts
